<div class="modal-header">
    <h5 class="modal-title">{{tituloModal}}</h5>
</div>
<div class="modal-body">
    <div class="container">
        <div class="row">
            <div class="col-sm">
                <p style="text-align: center;"><b>{{textoModal}}<br>{{preguntaModal}}</b></p>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="container">
        <div class="row">
            <div class="col-sm"></div>
            <div class="col-sm">
                <button type="button" class="btn btn-light" (click)="activeModal.close(false)">No</button>
            </div>
            <div class="col-sm"></div>
            <div class="col-sm">
                <button type="button" class="btn btn-light" (click)="activeModal.close(true)">Si</button>
            </div>
            <div class="col-sm"></div>
        </div>
    </div>
</div>
